export default __webpack_public_path__ + "img/icon-fullscreen-active.7b381f3e.svg";